
import { ListGroup } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import '../../css/chat_page.css';
import ViewChatPage from './ViewChatPage';
import { getRoomInitialSync } from '../matrix/matrixFuntions';

function ChatsList() {
  const dispatch = useDispatch();

  const chatDetails = useSelector(state => state.chatDetails);
  const loginDetails = useSelector(state => state.loginDetails);
  var serviceTypes = [];
  if (loginDetails != null) {
    serviceTypes = loginDetails.serviceTypes;
  }
  var selectedRoom;
  var joinedRooms;
  var joinedRoomArray = [];
  const matrixClient = chatDetails.matrixClient;
  if (chatDetails) {
    joinedRooms = chatDetails.joinedRooms;
    Object.entries(joinedRooms).forEach(([roomId, room]) => {
      joinedRoomArray.push(room);
    })
    selectedRoom = chatDetails.selectedRoom;
  }

  const handleChatRoomChange = (chatRoom) => {
    dispatch({
      type: 'setSelectedChatRoom',
      payload: chatRoom
    });
    if (matrixClient) {
      getRoomInitialSync(chatRoom.roomId, matrixClient, dispatch);
      // getJoinedMembers(chatRoom.roomId, matrixClient, dispatch)
    }
    document.getElementById("view-chat-staff").display = "block";
  }


  return (
    <div className='chat-parent-div'>
      <div >
        <div className='chat-page-left-div'>
          <div className='chat-rooms-list'>
            <div className='chat-room-outer-div'>
              <div className='chat-room-inner-div'>
                <ListGroup className='listgroup' >

                  {joinedRoomArray && joinedRoomArray.map((room) => (
                    <ListGroup.Item action key={`room-${room.roomId}`} className='chat-item'>
                      <div className='chat-list-item' onClick={() => handleChatRoomChange(room)}>
                        {room.name}
                        <hr />
                      </div>
                    </ListGroup.Item>
                  ))}

                </ListGroup>
              </div>
            </div>

          </div>
        </div>
        <div className='chat-page-right-div'>
          <ViewChatPage
            selectedRoom={selectedRoom}
            serviceTypes={serviceTypes} />
        </div>
      </div>
    </div>
  );
}

export default ChatsList;
